import { DashboardModule, Form } from '@domain-group/suit-theme'

import { UseCampaignFormPayload } from '@hooks/useCampaign'

import InfoToolTip from '@components/InfoToolTip'
import ToggleListItem from '@components/ToggleListItem'

type AmlComplianceProps = {
  campaignFormPayload: UseCampaignFormPayload,
}
const AmlCompliance = (props: AmlComplianceProps) => {
  const { campaignFormPayload } = props

  const { entityState, setEntityState } = campaignFormPayload

  return (
    <DashboardModule
      title="Compliance Settings"
      headerRight={(
        <InfoToolTip>
          These settings display the AML (Anti-Money Laundering and Counter-Terrorism Financing Act 2006) status for the vendor and purchaser linked to this campaign.
          <br />
          <br />
          You cannot approve quotes or order new property marketing items until the vendor&apos;s AML status is confirmed as complete (Yes).
          <br />

          If the status is &apos;No&apos; these actions will be disabled to ensure regulatory compliance.
        </InfoToolTip>
      )}
    >
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => (
            setEntityState({
              ...entityState,
              vendor_aml_complete: !entityState.vendor_aml_complete,
            })
          )}
          toggleValue={entityState.vendor_aml_complete}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Vendor AML Complete</ToggleListItem.Title>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => (
            setEntityState({
              ...entityState,
              purchaser_aml_complete: !entityState.purchaser_aml_complete,
            })
          )}
          toggleValue={entityState.purchaser_aml_complete}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>Purchaser AML Complete</ToggleListItem.Title>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

export default AmlCompliance
